import { render, staticRenderFns } from "./Asc.vue?vue&type=template&id=19d95a3e&"
import script from "./Asc.vue?vue&type=script&lang=js&"
export * from "./Asc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports